module.exports = __webpack_public_path__ + "assets/img/ecg-wufa-icon.77ad9151.png";